import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_FAVICON = '/favicon.png';

// Favicon dinámico de la pestaña del navegador = logo de la empresa.
// Prioriza la URL directa del logo (evita el redirect 307 del endpoint);
// si no hay, usa el endpoint por código; si no, el favicon por defecto.
const useDynamicFavicon = (empresaCodigo, logoUrl) => {
  useEffect(() => {
    let link = document.getElementById('dynamic-favicon') || document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.id = 'dynamic-favicon';
      document.head.appendChild(link);
    }
    let href = DEFAULT_FAVICON;
    if (logoUrl) {
      href = logoUrl.startsWith('http') || logoUrl.startsWith('data:') ? logoUrl : `${API_URL}${logoUrl}`;
    } else if (empresaCodigo) {
      href = `${API_URL}/api/empresas/${empresaCodigo}/logo`;
    }
    link.type = 'image/png';
    link.href = href;
  }, [empresaCodigo, logoUrl]);
};

export default useDynamicFavicon;
